import { BILL_FORECAST_SUCCESS, BILL_FORECAST_FAILURE ,BILL_FORECAST_REQUEST } from "./bill-forcast-constants";

const initialState = {
    loading: false,
    data: [],
    error: ''
  }
  
  export const billForecastReducer = (state = initialState, action) => {
    switch (action.type) {
      case BILL_FORECAST_REQUEST:
        return {
          ...state,
          loading: true
        }
      case BILL_FORECAST_SUCCESS:
        return {
            ...state,
          loading: false,
          data: action.payload,
          error: ''
        }
      case BILL_FORECAST_FAILURE:
        return {
            ...state,
          loading: false,
          data: [],
          error: action.payload
        }
      default: return state
    }
  }
  